import UserManagementRoutes from "./UserManagement/UserManagementRoutes";
import MastersRoutes from "./Masters/MastersRoutes";
import EnquiryRoutes from "./Enquiry/EnquiryRoutes";
import QuotationRoutes from "./Quotation/QuotationRoutes";
import SalesOrderRoutes from "./SalesOrder/SalesOrderRoutes";
import PurchaseManagementRoutes from "./PurchaseManagement/PurchaseManagementRoutes";
import InventoryRoutes from "./Inventory/InventoryRoutes";
import WarehouseRoutes from "./Warehouse/WarehouseRoutes";
import PaymentManagementRoutes from "./PaymentManagement/paymentroutes";

const AllRoutes: any = [
  ...UserManagementRoutes,
  ...MastersRoutes,
  ...EnquiryRoutes,
  ...QuotationRoutes,
  ...SalesOrderRoutes,
  ...PurchaseManagementRoutes,
  ...InventoryRoutes,
  ...WarehouseRoutes,
  ...PaymentManagementRoutes,
];

export default AllRoutes;
